/* eslint-disable react-hooks/exhaustive-deps */
/* พิมพ์ใบเลือกวัสดุ (A4)   /print/selection/:code */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Flex, Spin, message } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { SelectionService, apiError } from "../../../service/Ak.service";
import { fileUrl, formatMoney } from "../../../utils/util";
import logo from "../../../assets/images/logo_ak_full.png";

export default function SelectionPrint() {
  const { code } = useParams();
  const [s, setS] = useState(null);

  useEffect(() => {
    SelectionService.get(code)
      .then((r) => setS(r.data?.data))
      .catch((e) => message.error(apiError(e, "โหลดข้อมูลไม่สำเร็จ")));
  }, [code]);

  if (!s) return <Flex justify="center" style={{ padding: 80 }}><Spin /></Flex>;

  const site = [s.site_address, s.site_district, s.site_province].filter(Boolean).join(" ");
  const total = (s.items || []).reduce((a, i) => a + Number(i.price_diff || 0), 0);

  return (
    <div className="ak-print-wrap">
      <Flex justify="end" className="no-print" style={{ maxWidth: 820, margin: "12px auto" }}>
        <Button type="primary" icon={<PrinterOutlined />} onClick={() => window.print()}>
          พิมพ์
        </Button>
      </Flex>
      <div className="ak-print">
        <div className="ak-print-head">
          <img src={logo} alt="AK-HOME" />
          <div>
            <h1>ใบยืนยันการเลือกวัสดุ</h1>
            <div>เลขที่ {s.sel_code} · วันที่ {dayjs(s.sel_date).format("DD/MM/YYYY")}</div>
            <div>สถานะ: {s.status}</div>
          </div>
        </div>

        <table className="ak-print-info">
          <tbody>
            <tr>
              <th>ลูกค้า</th>
              <td>{[s.prename, s.cus_name].filter(Boolean).join(" ")} {s.cus_tel ? `โทร ${s.cus_tel}` : ""}</td>
              <th>โปรเจ็กต์</th>
              <td>{s.project_name} ({s.project_code})</td>
            </tr>
            <tr>
              <th>แบบบ้าน</th>
              <td>{s.model_code ? `${s.model_code} ${s.model_name || ""}` : "-"}</td>
              <th>สถานที่</th>
              <td>{site || "-"}</td>
            </tr>
          </tbody>
        </table>

        <table className="ak-print-table">
          <thead>
            <tr>
              <th style={{ width: 36 }}>#</th>
              <th>พื้นที่ / รายการ</th>
              <th style={{ width: 64 }}>รูป</th>
              <th>วัสดุที่เลือก</th>
              <th style={{ width: 90 }}>ประเภท</th>
              <th style={{ width: 110 }}>ส่วนต่าง (บาท)</th>
            </tr>
          </thead>
          <tbody>
            {(s.items || []).map((it, i) => (
              <tr key={it.id}>
                <td className="c">{i + 1}</td>
                <td>
                  <b>{it.item_name}</b>
                  <div className="muted">
                    {[it.area, it.qty ? `${formatMoney(it.qty, Number(it.qty) % 1 ? 2 : 0)} ${it.unit || ""}` : null].filter(Boolean).join(" · ")}
                  </div>
                  {it.note && <div className="muted">หมายเหตุ: {it.note}</div>}
                </td>
                <td className="c">{it.image_path ? <img src={fileUrl(it.image_path)} alt="" className="thumb" /> : null}</td>
                <td>
                  {it.mat_name || (it.tpl_item_id ? "-" : "ตามที่ตกลง")}
                  <div className="muted">{[it.brand, it.model, it.color].filter(Boolean).join(" · ")}</div>
                </td>
                <td className="c">{it.tpl_item_id ? (it.option_type === "upgrade" ? "อัปเกรด" : "มาตรฐาน") : "รายการพิเศษ"}</td>
                <td className="r">{Number(it.price_diff) ? formatMoney(it.price_diff, 2) : "-"}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={5} className="r"><b>รวมส่วนต่างที่ลูกค้าชำระเพิ่ม</b></td>
              <td className="r"><b>{formatMoney(total, 2)}</b></td>
            </tr>
          </tfoot>
        </table>

        {s.remark && <p className="muted">หมายเหตุ: {s.remark}</p>}

        <div className="ak-print-sign">
          <div>
            {s.signature_path ? <img src={fileUrl(s.signature_path)} alt="ลายเซ็นลูกค้า" /> : <div className="line" />}
            <div>( {s.signer_name || "........................................"} )</div>
            <div className="muted">ลูกค้า {s.locked_date ? `· ${dayjs(s.locked_date).format("DD/MM/YYYY HH:mm")}` : ""}</div>
          </div>
          <div>
            <div className="line" />
            <div>( {s.locked_by_name || "........................................"} )</div>
            <div className="muted">เจ้าหน้าที่ AK-HOME</div>
          </div>
        </div>
      </div>
    </div>
  );
}
